<template>
  <div v-if="gp !== undefined">
    <div class="subgroup-title" v-html="head"></div>
    <canvas id="myChart" width="740" height="370"></canvas>
  </div>

<!--  <input type="radio" name="chart_date_period" checked value="1" id="chart_date_period_month"/>-->
<!--  <input type="radio" name="chart_date_period" value="2" id="chart_date_period_quarter"/>-->
<!--  <input type="radio" name="chart_date_format" checked value="1" id="chart_date_format_short"/>-->
<!--  <input type="radio" name="chart_date_format" value="2" id="chart_date_format_full"/>-->
<!--  <div class="left-block">-->
<!--    <label :class="{selected: period == 1}" @click="changeLabelsPeriod( 1)" class="label_chart_button chart_date_period_button" for="chart_date_period_month">Ежемесячно</label>-->
<!--    <label :class="{selected: period == 2}" @click="changeLabelsPeriod( 2)" class="label_chart_button chart_date_period_button" for="chart_date_period_quarter">Ежеквартально</label>-->
<!--  </div>-->
<!--  <div class="right-block">-->
<!--    <label :class="{selected: format == 1}" @click="changeLabelsFormat( 1)" class="label_chart_button chart_date_format_button" for="chart_date_format_short">Сокращённые</label>-->
<!--    <label :class="{selected: format == 2}" @click="changeLabelsFormat( 2)" class="label_chart_button chart_date_format_button" for="chart_date_format_full">Полные</label>-->
<!--  </div>-->
</template>

<script>
import Chart from "chart.js/auto";
import { shallowRef } from "vue";

export default {
  name: "ChartComponent2",

  data: () => {
    return {
      checkDates: [],
      labels: [],
      search: [],
      gp: [],
      diff: 0,
      sets: [],
      chart: shallowRef(null),
      period: 1,
      format: 2,
      type: '',
      head: '',
      tech: '',
    }
  },
  async mounted() {
    await this.getContractChartPoints()
  },
  methods: {
    async getContractChartPoints() {
      const contract = this.$myApp.contract.get();
      this.tech = this.$myApp.tech.get();
      const api = await this.$api2.get({
        action: 'get-contract-graphic-points',
        object: "cpa",
        type: '',
        agreement_id: this.$route.params.token ? this.$route.params.id : contract.agreement_id,
        contract_id: this.$route.params.token ? this.$route.params.id : contract.contract_id,
        version_id: this.$route.params.token ? this.$route.params.id : contract.version_id,
        cover_id: this.$route.params.token ? this.$route.params.id : contract.cover_id,
        document_id: this.$route.params.token ? this.$route.params.id : contract.document_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      })
      if (api.success) {
        // console.log(api.data.graphic_points.graphic_points.error)
        // Антикостин
        if (api.data.graphic_points.graphic_points.error !== undefined && api.data.graphic_points.graphic_points.error.code > 0) {
          this.gp = undefined;
          return;
        }
        this.gp = api.data.graphic_points.graphic_points.data;
        // console.log(this.gp)
        this.type = api.data.graphic_points.graphic_points.type;
        this.head = api.data.graphic_points.graphic_points.head;
        if (api.data.graphic_points.graphic_points.labels_fix_dates !== undefined) this.checkDates = api.data.graphic_points.graphic_points.labels_fix_dates
        if (api.data.graphic_points.graphic_points.labels_barrier !== undefined) this.checkDates = api.data.graphic_points.graphic_points.labels_barrier

        this.buildArrayDates();
        this.buildDataSets();
        this.createChart();
      }
    },
    createChart() {
      const type = this.type;
      const checkDates = this.checkDates;
      const ctx = document.getElementById('myChart');
      let tension = 1;
      if (this.tech.pr.value === 'ka' || this.tech.pr.value === 'ps' || this.tech.pr.value === 'mb') {
        tension = 0;
      }
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: this.sets,
        },
        options: {
          tension: tension,
          pointStyle: false,
          pointRadius: 3,
          responsive: true,
          interaction: {
            mode: 'index',
            axis: 'y'
          },
          plugins: {
            tooltip: {
              bodySpacing: 5,
              bodyAlign: 'center',
              padding: {
                left: 20,
                right: 20,
                top: 20,
                bottom: 20,
              },
              itemSort: function (a, b) {
                return b.raw - a.raw
              },
              callbacks: {
                labelTextColor: function(context) {
                  if (type === 'option_fix_date' || type === 'coupon') {
                    if (checkDates.includes(context.label))
                      return '#f8ed02';
                  }
                },
                labelColor: function(context) {
                  if (type === 'option_fix_date' || type === 'coupon') {
                    if (checkDates.includes(context.label))
                      return {
                        borderColor: 'rgb(125,248,1)',
                        backgroundColor: 'rgb(255, 0, 0)',
                        borderWidth: 2,
                        borderDash: [2, 2],
                        borderRadius: 2,
                      };
                  }
                },
              },
            },
          },
        }
      });
    },
    buildArrayDates() {
      let minDate = new Date(),
        maxDate = new Date('2015-01-01'),
        arrayDateLabels = [],
        arrayDatesSearch = [];

      for ( let item in this.gp ) {

        let minD = new Date( this.gp[item].points[0].date ),
        maxD = new Date( this.gp[item].points[this.gp[item].points.length-1].date );
        if ( minD < minDate ) {
          minDate = new Date( this.gp[item].points[0].date );
        }
        if ( maxD > maxDate ) {
          maxDate = new Date( this.gp[item].points[this.gp[item].points.length-1].date );
        }
      }

      this.diff = ( maxDate - minDate  ) / 1000 / 60 / 60 / 24;

      // если начинать не с 0 - теряем первый день; без + 1 в diff теряем последний день
      for ( let i = 0; i < this.diff + 1; i++ ) {
        // без добавления +3 часов в некоторых графиках в форматах arrayDatesSearch и arrayDateLabels теряется день
        let newDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate() + i, 3);
        arrayDatesSearch.push( newDate.toISOString().split('T')[0] );
        arrayDateLabels.push( newDate.toLocaleDateString('ru-RU') );
      }
      this.checkDates = this.checkDates.map((d) => {
        let nd = new Date(d);
        return nd.toLocaleDateString('ru-RU')
      })
      this.labels = arrayDateLabels;
      this.search = arrayDatesSearch;
    },
    buildDataSets() {
      let colors = [];
      // console.log(this.gp);
      if (this.gp?.length > 1) {
        colors = [
          '#9d9d9d',
          '#ec607d',
          '#59c6f1',
          '#a0c515',
          '#f9a600',
          '#974b96',
          '#c962ca',
          '#5c60b8',
          '#4689ea',
          '#59cd9d',
          '#ddca00',
          '#ee7a60',
        ]
      } else {
        colors = ['#0075D4']
      }
      for (let unit in this.gp) {
        let dash = [], bk = '';
        if (this.gp[unit].type === 'barrier') {
          dash = [5, 5];
          bk = '#7d7d7d';
        }
        else {
          bk = colors[unit];
        }
        let set = {
          label: this.gp[unit].name,
          data: this.buildPoints(this.gp[unit].points),
          borderWidth: 3,
          borderDash: dash,
          borderColor: bk,
        }
        this.sets.push(set)
      }
    },
    buildPoints(points) {
      let obj = {}, r = [];
      points.forEach(item => {
        obj[item.date] = item.value;
      });
      this.search.forEach((d, i) => {
        if (obj[d] === undefined || obj[d] === 0) {
          r.push(r[i-1]);
        }
        else {
          r.push(obj[d]);
        }
      });
      return r;
    },

    // changeLabelsFormat(rf) {
    //   this.format = rf;
    //   this.chart.data.labels = this.labels.map(x => {
    //     if( rf === 1 ){
    //       x = x.split('.');
    //       return x[1] + '.' + x[2].substr(-2, 2) + '   ';
    //     }else{
    //       return x + '   ';
    //     }
    //   });
    //   this.chart.update();
    // },

    // changeLabelsPeriod (rp) {
    //   this.period = rp;
    //   if (rp === 1) {
    //     if (this.format === 1) this.chart.data.labels = this.cropLabelsMonth;
    //     else this.chart.data.labels = this.fullLabelsMonth;
    //   }
    //   else {
    //     if (this.format === 1) this.chart.data.labels = this.cropLabelsQuarter;
    //     else this.chart.data.labels = this.fullLabelsQuarter;
    //   }
    //   this.chart.update();
    // },
  },
}
</script>

<style scoped>
@media only screen and (max-width:579px) {
  #chart-component {
    width: 85vw;
    position: relative;
  }
}
</style>